export const ADMIN_PATH = process.env.ADMIN_PATH ?? "/xp7m2";
